import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IBaseResponse } from '../../../utilities/http-utilities.service';

@Injectable()
export class AiReportCommentButtonService {
  private readonly http = inject(HttpClient);

  /** The API saves the comment on the item's own board and checks the user can reach it. */
  public addComment(itemId: number, description: string): Observable<IBaseResponse<unknown>> {
    return this.http.post<IBaseResponse<unknown>>('item-comments', { description, itemId });
  }
}
